export const calculateRowNumber = (
  index: number,
  currentTilesPerRow: number,
) => {
  if (currentTilesPerRow === 0) {
    return 1
  }
  return Math.ceil((index + 1) / currentTilesPerRow)
}
